<template>
    <el-table-column
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot="scope">
        <slot v-bind="scope"></slot>
      </template>
    </el-table-column>
  </template>
  
  <script>
  export default {
    name: 'table-column-element',
  };
  </script>
  
<script>
export default {
  props: {
    currencySymbol: { type: String, default: null },
    tableColumnType: { type: String, default: 'default' }, // новый параметр
  },
  methods: {
    isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/table-column-element.vue